module.exports = __webpack_public_path__ + "static/media/9.bf3cb384.svg";